import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";

const routes: Routes = [
  {
    path: "home",
    loadChildren: () => import("./home/home.module").then((m) => m.HomePageModule),
  },
  {
    path: "",
    redirectTo: "home",
    pathMatch: "full",
  },
  {
    path: "ejercicio-seleccion",
    loadChildren: () =>
      import("./ejercicios/ejercicios-seleccion/ejercicio-seleccion/ejercicio-seleccion.module").then(
        (m) => m.EjercicioSeleccionPageModule
      ),
  },
  {
    path: "categorias/orientacion",
    loadChildren: () => import("./categorias/orientacion/orientacion.module").then((m) => m.OrientacionPageModule),
  },
  {
    path: "categorias/lenguaje",
    loadChildren: () => import("./categorias/lenguaje/lenguaje.module").then((m) => m.LenguajePageModule),
  },
  {
    path: "categorias/atencion",
    loadChildren: () => import("./categorias/atencion/atencion.module").then((m) => m.AtencionPageModule),
  },
  {
    path: "categorias/calculo",
    loadChildren: () => import("./categorias/calculo/calculo.module").then((m) => m.CalculoPageModule),
  },
  {
    path: "categorias/memoria",
    loadChildren: () => import("./categorias/memoria/memoria.module").then((m) => m.MemoriaPageModule),
  },
  {
    path: "categorias/funciones",
    loadChildren: () => import("./categorias/funciones/funciones.module").then((m) => m.FuncionesPageModule),
  },
  {
    path: "categorias/praxias",
    loadChildren: () => import("./categorias/praxias/praxias.module").then((m) => m.PraxiasPageModule),
  },
  {
    path: "categorias/areasocupacion",
    loadChildren: () =>
      import("./categorias/areasocupacion/areasocupacion.module").then((m) => m.AreasocupacionPageModule),
  },
  {
    path: "categorias/esquema",
    loadChildren: () => import("./categorias/esquema/esquema.module").then((m) => m.EsquemaPageModule),
  },
  {
    path: "loading",
    loadChildren: () => import("./categorias/components/loading/loading.module").then((m) => m.LoadingPageModule),
  },
  {
    path: "login",
    loadChildren: () => import("./login/login.module").then((m) => m.LoginPageModule),
  },
  {
    path: "perfil",
    loadChildren: () => import("./perfil/perfil.module").then((m) => m.PerfilPageModule),
  },
  {
    path: "estadisticas",
    loadChildren: () => import("./estadisticas/estadisticas.module").then((m) => m.EstadisticasPageModule),
  },
  {
    path: "standalone/lugar-adecuado",
    loadChildren: () =>
      import("./ejercicios/standalone/lugar-adecuado/lugar-adecuado.module").then((m) => m.LugarAdecuadoPageModule),
  },
  {
    path: "standalone/objeto-unico",
    loadChildren: () =>
      import("./ejercicios/standalone/objeto-unico/objeto-unico.module").then((m) => m.ObjetoUnicoPageModule),
  },
  {
    path: "standalone/puzle-visual",
    loadChildren: () =>
      import("./ejercicios/standalone/puzle-visual/puzle-visual.module").then((m) => m.PuzleVisualPageModule),
  },  {
    path: 'questionnaire-burgos',
    loadChildren: () => import('./questionnaire-burgos/questionnaire-burgos.module').then( m => m.QuestionnaireBurgosPageModule)
  },
  {
    path: 'main',
    loadChildren: () => import('./main/main.module').then( m => m.MainPageModule)
  },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      useHash: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
